import differenceInYears from "date-fns/differenceInYears";

export const getYearDiff = (start: number, end: number): number => {
  return differenceInYears(end, start);
};

export const isOver12 = (dob: Date): boolean => {
  return getYearDiff(dob.getTime(), Date.now()) > 12;
}
